let loading = require( './loading' );
let organisations_ajax = require( './organisations-ajax' );

let manage_practice_billing_address = function( $ ) {

	let $wrapper,
		cancel_action = 'undo-separate-billing', // This should represent what the cancel link should do when clicked at any point
		anim_speed = 400;

	let _init = function() {
		$wrapper = $( '#manage-practice-billing-address' );

		if ( $wrapper.length > 0 ) {
			_setup_toggle_separate_address_form();
			_setup_practices_lazy_load();
			_setup_edit_billing_address();
			_setup_cancel_click();
			_setup_billing_address_form();
		}
	};

	let _clear_address_form = function() {
		let $form = $( 'form.separate-organisation-select ' );

		_clear_address_form_errors();

		$form.find( 'select, input[type="text"]' ).val( '' ).trigger( 'change' );
	};

	let _setup_toggle_separate_address_form = function() {
		let $form     = $( 'form.separate-billing-address-toggle' ),
			$checkbox = $form.find( '#toggle-practice-separate-address' );

		$checkbox.on( 'change', ( e ) => {
			$form.submit();
		} );

		$form.on( 'submit', function( e ) {
			e.preventDefault();

			$wrapper.loading();

			// Value needs to be reversed due to designs
			_update_separate_address( ! $checkbox.is( ':checked' ) );
		} );
	};

	let _show_separate_billing_address_panel = function() {
		let $billing_panel  = $( '#billing-address-panel' ),
			$practice_panel = $( '#practice-address' );

		if ( ! $billing_panel.hasClass( 'out' ) ) {
			$practice_panel.addClass( 'greyed' );
			return;
		}

		$billing_panel.slideDown( anim_speed );

		setTimeout( () => {
			$billing_panel.removeClass( 'out' );
			$practice_panel.addClass( 'greyed' );
		}, anim_speed );
	};

	let _hide_separate_billing_address_panel = function() {
		let $billing_panel  = $( '#billing-address-panel' ),
			$practice_panel = $( '#practice-address' );

		if ( $billing_panel.hasClass( 'out' ) ) {
			$practice_panel.removeClass( 'greyed' );
			return;
		}

		$billing_panel.slideUp( anim_speed );

		setTimeout( () => {
			$billing_panel.addClass( 'out' );
			$practice_panel.removeClass( 'greyed' );
		}, anim_speed );
	};

	let _update_billing_address = function( address_string ) {
		let $billing_panel = $( '#billing-address-panel' );

		$billing_panel.find( '.entry-content' ).text( address_string );
	};

	let _update_separate_address = function ( value ) {
		let data = {
			nonce: ScriptData.crate_practice_update_has_separate_billing_address,
			action: 'crate_practice_update_separate_billing',
			enabled: value
		};

		$.post( ScriptData.ajaxurl, data, ( response ) => {
			if ( response.success ) {
				if ( response.separate_billing && response.billing_address ) {
					_update_billing_address( response.billing_address );
					_show_separate_billing_address_panel();
				} else if ( response.separate_billing ) {
					_show_billing_address_form();
				} else {
					_hide_separate_billing_address_panel();
					_hide_billing_address_form();
				}
			} else {
				window.alert( 'Woop\'s something has gone wrong, please refresh and try again.' );
			}

			$wrapper.loaded();
		} );
	};

	let _show_billing_address_form = function() {
		let $form = $( 'form.separate-organisation-select' );

		if ( ! $form.hasClass( 'out' ) ) {
			return;
		}

		_clear_address_form();

		$form.slideDown( anim_speed );

		setTimeout( () => {
			$form.removeClass( 'out' );
		}, anim_speed );
	};

	let _hide_billing_address_form = function() {
		let $form = $( 'form.separate-organisation-select' );

		if ( $form.hasClass( 'out' ) ) {
			return;
		}

		_clear_address_form();

		$form.slideUp( anim_speed );

		setTimeout( () => {
			$form.addClass( 'out' );
		}, anim_speed );
	};

	let _setup_practices_lazy_load = function() {
		let $select = $wrapper.find( 'select#field_organisation-lookup' );

		$select.select2({
			dropdownParent: $select.closest( '.field-wrap' ),
			ajax: {
				url : ScriptData.ajaxurl,
				method: 'POST',
				dataType : 'json',
				delay : 250,
				data : organisations_ajax.get_select2_options
			}
		});
	};

	let _setup_edit_billing_address = function() {
		$wrapper.find( '.change-billing-address' ).on( 'click', function( e ) {
			e.preventDefault();

			cancel_action = 'hide-billing-organisation-select';

			_hide_separate_billing_address_panel();
			_show_billing_address_form();
		} )
	};

	let _setup_billing_address_form = function() {
		let $form = $wrapper.find( 'form.separate-organisation-select' );

		$form.find( '#toggle-practice-manually-entered-address' ).on( 'change', function ( e ) {
			_update_billing_address_manually_entered_toggle( $( this ).is( ':checked' ) );
			_clear_address_form();
		} );

		$form.on( 'submit', function( e ) {
			e.preventDefault();

			$wrapper.loading();

			let type = $form.find( '#toggle-practice-manually-entered-address' ).is( ':checked' ) ? 'manual' : 'lookup';

			_submit_address_form( type );
		} );
	};

	let _submit_address_form = function( type ) {
		let $form = $( 'form.separate-organisation-select' );

		if ( type === 'lookup' ) {
			let organisation = $form.find( '#field_organisation-lookup' ).val();

			if ( organisation ) {
				_update_billing_organisation( organisation );
			} else {
				_add_notice( 'error', 'Please select an organisation or enter an address manually' );
				$wrapper.loaded();
			}
		} else {
			let name        = $form.find( '#field_practice_billing_address_manual_name' ).val(),
				addr_line_1 = $form.find( '#field_practice_billing_address_manual_line_1' ).val(),
				addr_line_2 = $form.find( '#field_practice_billing_address_manual_line_2' ).val(),
				town_city   = $form.find( '#field_practice_billing_address_manual_town' ).val(),
				postcode    = $form.find( '#field_practice_billing_address_manual_postcode' ).val();

			_update_billing_manual_address( name, addr_line_1, addr_line_2, town_city, postcode );
		}
	};

	let _update_billing_organisation = function( organisation ) {
		let data = {
			nonce: ScriptData.crate_practice_update_billing_organisation,
			action: 'crate_practice_update_billing_organisation',
			organisation: organisation
		};

		$.post( ScriptData.ajaxurl, data, ( response ) => {
			if ( response.success ) {
				_hide_billing_address_form();
				_update_billing_address( response.billing_address_string );
				_show_separate_billing_address_panel();

				// Clear the form
				_clear_address_form();
			} else {

				if ( response.error ) {
					_add_notice( 'error', response.error );
				}
			}

			$wrapper.loaded();
		} );
	};

	let _update_billing_manual_address = function( name, line_1, line_2, town, postcode ) {
		$wrapper.loading();

		_clear_address_form_errors();

		let should_submit = _validate_manual_address_form( true );

		let data = {
			nonce: ScriptData.crate_practice_update_manual_billing_address,
			action: 'crate_practice_update_manual_billing_address',
			name: name,
			addr_line_1: line_1,
			addr_line_2: line_2,
			town : town,
			postcode : postcode,
		};

		if ( should_submit ) {
			$.post( ScriptData.ajaxurl, data, ( response ) => {
				if ( response.success ) {
					_hide_billing_address_form();
					_update_billing_address( response.billing_address_string );
					_show_separate_billing_address_panel();

					// Clear the form
					_clear_address_form();
				} else {
					if ( response.error ) {
						_add_notice( 'error', response.error );
					} else {
						window.alert( 'Woop\'s something has gone wrong, please refresh and try again.' );
					}
				}

				$wrapper.loaded();
			} );
		} else {
			$wrapper.loaded();
		}
	};

	let _validate_manual_address_form = function( add_messages = false ) {
		let $form            = $( 'form.separate-organisation-select' ),
			success          = true,
			added_main_error = false;

		if ( ! $form.find( '#field_practice_billing_address_manual_name' ).val() ) {
			success = false;
			if ( add_messages ) {
				_add_address_form_error( 'field-wrap-address-manual-name', 'This is a required field' );

				if ( ! added_main_error ) {
					_add_notice( 'error', 'Some required fields are not filled in' );
				}
			}
		}

		if ( ! $form.find( '#field_practice_billing_address_manual_line_1' ).val() ) {
			success = false;
			if ( add_messages ) {
				_add_address_form_error( 'field-wrap-address-manual-line-1', 'This is a required field' );

				if ( ! added_main_error ) {
					_add_notice( 'error', 'Some required fields are not filled in' );
				}
			}
		}

		if ( ! $form.find( '#field_practice_billing_address_manual_town' ).val() ) {
			success = false;
			if ( add_messages ) {
				_add_address_form_error( 'field-wrap-address-manual-town', 'This is a required field' );

				if ( ! added_main_error ) {
					_add_notice( 'error', 'Some required fields are not filled in' );
				}
			}
		}

		if ( ! $form.find( '#field_practice_billing_address_manual_postcode' ).val() ) {
			success = false;
			if ( add_messages ) {
				_add_address_form_error( 'field-wrap-address-manual-postcode', 'This is a required field' );

				if ( ! added_main_error ) {
					_add_notice( 'error', 'Some required fields are not filled in' );
				}
			}
		}

		return success;
	};

	let _update_billing_address_manually_entered_toggle = function( value ) {
		$wrapper.loading();

		let data = {
			nonce: ScriptData.crate_practice_update_manually_entered_address_toggle,
			action: 'crate_practice_update_manually_entered_address_toggle',
			value: value
		};

		$.post( ScriptData.ajaxurl, data, ( response ) => {
			if ( response.success ) {
				if ( response.value ) {
					_toggle_address_fields_shown( 'manual' );
				} else {
					_toggle_address_fields_shown( 'lookup' );
				}
			} else {
				window.alert( 'Woop\'s something has gone wrong, please refresh and try again.' );
			}

			$wrapper.loaded();
		} );
	};

	let _toggle_address_fields_shown = function ( type ) {
		$wrapper.loading();

		_clear_address_form();

		let $form = $( 'form.separate-organisation-select' ),
			$groups = $form.find( '.field-conditional-group' );

		$groups.each( ( index, item ) => {
			let $group = $( item );

			if ( $group.hasClass( type ) ) {
				$group.slideDown( anim_speed );

				setTimeout( () => {
					$group.removeClass( 'out' );
				}, anim_speed )
			}
		} );

		$groups.not( '.' + type, '.out' ).slideUp( anim_speed );

		setTimeout( () => {
			$groups.not( '.' + type ).addClass( 'out' );
		}, anim_speed );

		$wrapper.loaded();
	};

	let _setup_cancel_click = function() {
		$wrapper.find( '.cancel-link' ).on( 'click', function( e ) {
			e.preventDefault();

			switch ( cancel_action ) {
				case 'undo-separate-billing':
					let $form     = $( 'form.separate-billing-address-toggle' ),
						$checkbox = $form.find( '#toggle-practice-separate-address' );

					if ( $checkbox.is( ':checked' ) ) {
						$checkbox.prop( 'checked', false );
					} else {
						$checkbox.prop( 'checked', true );
					}

					$checkbox.trigger( 'change' );
					break;
				case 'hide-billing-organisation-select':
					_hide_billing_address_form();
					_show_separate_billing_address_panel();
					break;
			}
		} )
	};

	let _clear_address_form_errors = function() {
		let $errors = $( 'form.separate-organisation-select .field-wrap.has-errors' );

		$errors.find( '.field-error' ).remove();
		$errors.removeClass( 'has-errors' );
	};

	let _add_notice = function( type, message ) {
		let $notices_wrapper = $wrapper.find( '.notices' );

		$notices_wrapper.find( '.notice' ).remove();

		$notices_wrapper.append( '<div style="display: none" class="notice ' + type + '">' + message + '<a href="#" class="close-popup"></a></div>' ).append( () => {
			$notices_wrapper.find( '.notice .close-popup' ).on( 'click', function( e ) {
				e.preventDefault();

				_clear_address_form_errors();

				$( this ).closest( '.notice' ).slideUp( anim_speed );

				setTimeout( () => {
					$( this ).closest( '.notice' ).remove();
				}, anim_speed )
			} );
		});

		$notices_wrapper.find( '.notice' ).slideDown( anim_speed );
	};

	let _add_address_form_error = function( field_wrap, error ) {
		let $form  = $( 'form.separate-organisation-select' ),
			$field = $form.find( '#' + field_wrap );

		$field.addClass( 'has-errors' );

		if ( error ) {
			$field.append( '<div class="error-message field-error">' + error + '</div>' )
		}
	};

	$( document ).ready( _init );

} ( jQuery );

module.exports = manage_practice_billing_address;